import React, { Component } from "react";
import redemptionImages from "../../assets/img/redemptionImages.jpg";

class RedemptionSample extends Component {
  render() {
    return (
      <div
        style={{
          width: "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <img
          className="imgStyle"
          src={redemptionImages}
          alt="redemptionImages"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
      </div>
    );
  }
}

export default RedemptionSample;
